/* Compact card purchases carry the same fulfillment property as the PDP. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const pending = new Set();
  function sync(cart) {
    if (!cart?.items) return;
    const ids = new Set(cart.items.map(item => String(item.variant_id)));
    document.querySelectorAll('[data-og-card-add][data-og-kind="digital"]').forEach(button => {
      if (!button.dataset.ogVariant) return;
      const inCart = ids.has(button.dataset.ogVariant);
      // Never unlock an unavailable offer.
      if (button.closest('.is-unavailable')) return;
      button.dataset.ogInCart = String(inCart);
      button.disabled = inCart || pending.has(button.dataset.ogVariant);
      button.querySelector('[data-og-cart-icon]').hidden = inCart;
      button.querySelector('[data-og-check-icon]').hidden = !inCart;
      if (!button.dataset.ogOriginalLabel) button.dataset.ogOriginalLabel = button.getAttribute('aria-label');
      button.setAttribute('aria-label', inCart ? 'Added to cart' : button.dataset.ogOriginalLabel);
    });
  }
  document.addEventListener('cart:updated', event => {
    if (event.detail?.items) sync(event.detail);
    else fetch(root + 'cart.js').then(response => response.json()).then(sync).catch(() => {});
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-og-card-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const id = button.dataset.ogVariant;
    if (pending.has(id)) return;
    pending.add(id);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const status = button.closest('.og-card-offers').querySelector('[role="status"]');
    status.textContent = '';
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1, properties: { '_Fulfillment Type': button.dataset.ogKind } }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please try again.');
      const cartResponse = await fetch(root + 'cart.js');
      if (!cartResponse.ok) throw new Error('Item added. Refresh the page to update your cart.');
      const cart = await cartResponse.json();
      pending.delete(id);
      sync(cart);
      window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      status.textContent = 'Added to cart';
      if (button.closest('.og-card-offers').dataset.ogCartRedirect === 'true') window.location.assign(root + 'cart');
      else document.querySelector('.site-header-cart--button')?.click();
    } catch (error) {
      status.textContent = error.message;
    } finally {
      pending.delete(id);
      button.removeAttribute('aria-busy');
      button.disabled = button.dataset.ogInCart === 'true';
    }
  });
})();
